(function() {
    'use strict';
    angular
        .module('gestioneAttiApp')
        .factory('CommissioneRuolo', CommissioneRuolo);

    CommissioneRuolo.$inject = ['$resource'];

    function CommissioneRuolo ($resource) {
        var resourceUrl =  'api/commissione-ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
